import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createOptionValue } from '../../../api/apiOptionGroups';
import { toast } from 'react-hot-toast';
import parseError from '../../../utils/parseError';

/**
 * Hook to create a new option value
 */
export const useCreateOptionValue = () => {
    const queryClient = useQueryClient();

    const { mutate: createOptionValueMutate, isPending: isCreating } = useMutation({
        mutationFn: ({ optionGroupId, data }) => createOptionValue(optionGroupId, data),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['optionValues'] });
            toast.success(res?.data?.message);
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message);
        }
    });

    return { createOptionValueMutate, isCreating };
};
